import { render, staticRenderFns } from "./WithdrawModal2.vue?vue&type=template&id=780b23f2&scoped=true&"
import script from "./WithdrawModal2.vue?vue&type=script&lang=js&"
export * from "./WithdrawModal2.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawModal2.vue?vue&type=style&index=0&id=780b23f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780b23f2",
  null
  
)

export default component.exports